import type { ParametersNewTemplate } from "./ParametersNewTemplate";

export const INITIAL_VALUES: ParametersNewTemplate = {
	TemplateId: null,
	AssetId: 1,
	AssetName: null,
	TypeCode: "PM",
	Title: "",
	CraftId: 1,
	DownHours: null,
	PlannedHours: 12,
	DowntimeClassCode: null,
	NumberOfWorkers: 1,
	PeriodShifts: null,
	ExpectedShifts: null,
	WarningShifts: null,
	Description: "",
	shiftsPerDay: 2,
	selectedPeriodDays: null,
	selectedWarningDays: null,
	selectedExpectedDays: null,
	SchedulingPolicyCode: "C",
	ScheduleStart: null,
	selectedCronExpression: "",
	CronExpression: "0 0 0 * * ?",
	NotifyOnGeneration: false,
	RecipientIds: [],
};
